import type { Point } from '../elements/point';
import type { Vector } from '../elements/vector';
import { GRID_SIZE } from './constants';

export function snapAxis(position: number): number {
  return Math.round(position / GRID_SIZE) * GRID_SIZE;
}

/**
 * Snap center of an object to a grid intersection.
 *
 * Example: object with size [10, 20] around zero coordinates
 * would be snapped to [0, 0], while object at [30, 50] would
 * go to [40, 40].
 *
 * @return new center coordinate of the object
 */
export function snapToGrid<T extends Partial<Point>>(center: T): T {
  return {
    x: center.x !== undefined ? snapAxis(center.x) : undefined,
    y: center.y !== undefined ? snapAxis(center.y) : undefined,
  } as T;
}

export function snapVector(vector: Vector): Vector {
  return {
    x:
      (vector.x > 0
        ? Math.ceil(vector.x / GRID_SIZE)
        : Math.floor(vector.x / GRID_SIZE)) * GRID_SIZE,
    y:
      (vector.y > 0
        ? Math.ceil(vector.y / GRID_SIZE)
        : Math.floor(vector.y / GRID_SIZE)) * GRID_SIZE,
  };
}
